import './CRUDSeller.scss';
import Component from './CRUDSeller.js';
export default Component;
